import {
  Box,
  Button,
  Card,
  CardBody,
  Checkbox,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Image,
  Input,
  Menu,
  MenuButton,
  MenuList,
  Text,
  Textarea,
  useToast,
  FormErrorMessage,
  HStack,
  Tag,
} from "@chakra-ui/react";
import React, { useEffect, useState, useRef } from "react";
import { FaChevronDown } from "react-icons/fa";
import { useFormik } from "formik";
import axios from "axios";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import { useSelector } from "react-redux";

const ProfessionalDetails = ({ coachData }) => {
  const [categories, setCategories] = useState([{}]);
  const [awardImages, setAwardImages] = useState([{ image: "" }]);
  const [isLoadingSubmitBtn, setIsLoadingSubmitBtn] = useState(false);
  const [categoryError, setCategoryError] = useState(false);
  const [renderOnSave, setRenderOnSave] = useState(0);
  const [playingExperienceImages, setPlayingExperienceImages] = useState([
    { image: "" },
  ]);
  const [coachingExperienceImages, setCoachingExperienceImages] = useState([
    { image: "" },
  ]);
  const [coachingQualificationsImages, setCoachingQualificationsImages] =
    useState([{ image: "" }]);
  const [isDiscardDisabled, setIsDiscardDisabled] = useState(false);
  const [formChanged, setFormChanged] = useState(false);
  const initialValuesRef = useRef(null);

  const toast = useToast();
  const { id } = useParams();
  const token = sessionStorage.getItem("admintoken").split(" ")[1];
  const userData = useSelector((state) => state.user);

  const handleFormChange = () => {
    setFormChanged(true);
    setIsDiscardDisabled(false);
  };

  const handleLanguageInput = (e) => {
    const raw = e.target.value || "";
    const cleaned = raw.replace(/[^A-Za-z\s,\'-]/g, "");
    formik.setFieldValue("language", cleaned);
    formik.setFieldTouched("language", true, false);
    handleFormChange();
  };

  const getCategories = async () => {
    try {
      let response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/category`
      );
      setCategories(response.data.data);
    } catch (error) {
      console.log(error);
      if (error.response.status === 403) {
        toast({
          title: "You don't have an access to perform this action",
          status: "warning",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      } else {
        toast({
          title: "Something went wrong please try again later",
          status: "error",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      }
    }
  };

  const addQualification = () => {
    if (formik.values.coachingQualifications.length >= 10) {
      toast({
        title: "Maximum 10 qualifications allowed",
        status: "warning",
        duration: 4000,
        position: "top",
        isClosable: true,
      });
      return;
    }
    formik.setValues({
      ...formik.values,
      coachingQualifications: [
        ...formik.values.coachingQualifications,
        {
          description: "",
          image: "",
        },
      ],
    });
    handleFormChange();
  };

  const addCoachingExperience = () => {
    if (formik.values.coachingExperience.length >= 10) {
      toast({
        title: "Maximum 10 coaching experiences allowed",
        status: "warning",
        duration: 4000,
        position: "top",
        isClosable: true,
      });
      return;
    }
    formik.setValues({
      ...formik.values,
      coachingExperience: [
        ...formik.values.coachingExperience,
        {
          description: "",
          image: "",
        },
      ],
    });
    handleFormChange();
  };

  const addPlayingExperience = () => {
    if (formik.values.playerExperience.length >= 10) {
      toast({
        title: "Maximum 10 playing experiences allowed",
        status: "warning",
        duration: 4000,
        position: "top",
        isClosable: true,
      });
      return;
    }
    formik.setValues({
      ...formik.values,
      playerExperience: [
        ...formik.values.playerExperience,
        {
          description: "",
          image: "",
        },
      ],
    });
    handleFormChange();
  };

  const addAwardExperience = () => {
    if (formik.values.award.length >= 10) {
      toast({
        title: "Maximum 10 awards allowed",
        status: "warning",
        duration: 4000,
        position: "top",
        isClosable: true,
      });
      return;
    }
    formik.setValues({
      ...formik.values,
      award: [
        ...formik.values.award,
        {
          description: "",
          image: "",
        },
      ],
    });
    handleFormChange();
  };

  const handleFileChange = async (e, fieldName, index) => {
    try {
      const file = e.currentTarget.files[0];
      if (file && file.size > 10 * 1024 * 1024) {
        toast({
          title: "Please select a file less than 10 MB",
          status: "warning",
          duration: 5000,
          position: "top",
          isClosable: true,
        });
        return;
      }

      const formData = new FormData();
      formData.append("image", file);

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/coach/uploadImage`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const url = response?.data?.url;
      if (url) {
        toast({
          title: "Image uploaded successfully",
          status: "success",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
        e.target.value = null;
      } else {
        toast({
          title: "Something went wrong while uploading  image",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
        e.target.value = null;
      }

      if (fieldName === "award") {
        formik.setFieldValue(`${fieldName}.${index}.image`, url);
        setAwardImages([...awardImages, { image: url }]);
      }
      if (fieldName === "playerExperience") {
        formik.setFieldValue(`${fieldName}.${index}.image`, url);
        setPlayingExperienceImages([
          ...playingExperienceImages,
          { image: url },
        ]);
      }
      if (fieldName === "coachingExperience") {
        formik.setFieldValue(`${fieldName}.${index}.image`, url);
        setCoachingExperienceImages([
          ...coachingExperienceImages,
          { image: url },
        ]);
      }
      if (fieldName === "coachingQualifications") {
        formik.setFieldValue(`${fieldName}.${index}.image`, url);
        setCoachingQualificationsImages([
          ...coachingQualificationsImages,
          { image: url },
        ]);
      }
      handleFormChange();
    } catch (error) {
      if (error.response.status === 403) {
        toast({
          title: "You don't have an access to perform this action",
          status: "warning",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      } else {
        toast({
          title: "Something went wrong please try again later",
          status: "error",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      }
    }
  };

  const deleteImageFiles = async (url, fieldName, index) => {
    if (!userData?.accessScopes?.coach?.includes("delete")) {
      toast({
        title: "You don't have an access to perform this action",
        status: "warning",
        duration: 4000,
        position: "top",
        isClosable: true,
      });
    } else {
      try {
        const formData = new FormData();
        formData.append("url", url);

        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/api/coach/uploadImage`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (fieldName === "award") {
          await formik.setFieldValue(`${fieldName}.${index}.image`, "");
        }
        if (fieldName === "playerExperience") {
          await formik.setFieldValue(`${fieldName}.${index}.image`, "");
        }
        if (fieldName === "coachingExperience") {
          await formik.setFieldValue(`${fieldName}.${index}.image`, "");
        }
        if (fieldName === "coachingQualifications") {
          await formik.setFieldValue(`${fieldName}.${index}.image`, "");
        }
        handleFormChange();

        const resp = response?.data;
        if (resp) {
          if (url) {
            toast({
              title: "Profile image deleted.",
              status: "success",
              duration: 3000,
              position: "top",
              isClosable: true,
            });
          } else {
            toast({
              title: "Something went wrong while deleting profile image.",
              status: "error",
              duration: 3000,
              position: "top",
              isClosable: true,
            });
          }
        }
      } catch (error) {
        console.log(error);
        if (error.response.status === 403) {
          toast({
            title: "You don't have an access to perform this action",
            status: "warning",
            duration: 4000,
            position: "top",
            isClosable: true,
          });
        } else {
          toast({
            title: "Something went wrong please try again later",
            status: "error",
            duration: 4000,
            position: "top",
            isClosable: true,
          });
        }
      }
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  const formik = useFormik({
    initialValues: {
      experience: coachData?.experience || "",
      language: coachData?.language || "",
      sportsCategories: coachData?.sportsCategories || [],
      coachingQualifications: coachData?.coachingQualifications?.filter(
        (x) => x.description.length > 0
      ) || [{ description: "", image: "" }],
      coachingExperience: coachData?.coachingExperience || [
        { description: "", image: "" },
      ],
      playerExperience: coachData?.playerExperience || [
        { description: "", image: "" },
      ],
      award: coachData?.award || [{ description: "", image: "" }],
    },
    validationSchema: Yup.object().shape({
      experience: Yup.number("Only Number are allowed")
        .min(0.1, "Experience must be greater than 0")
        .max(99, "can not more than 99 years")
        .test('decimal-places', 'Maximum 1 decimal place allowed', (value) => {
          if (value === null || value === undefined || Number.isNaN(value)) return true;
          return /^\d+(\.\d{1})?$/.test(value.toString());
        })
        .required("Experience is required"),
      language: Yup.string()
        .required("At least one language is required")
        .test('no-empty-spaces', 'Language cannot be empty or contain only spaces', function(value) {
          return value && value.trim().length > 0;
        })
        .matches(/^[A-Za-z\s,\'-]+$/, 'Language can only contain alphabets, spaces, commas, hyphens and apostrophes')
        .test('min-letters', 'Language must contain at least 3 characters', function(value) {
          if (!value) return false;
          const lettersOnly = value.replace(/[^A-Za-z]/g, '');
          return lettersOnly.length >= 3;
        }),
      sportsCategories: Yup.array()
        .min(1, "At least one sports category is required")
        .required("Sports categories are required"),
    }),
    onSubmit: (values) => {
      setIsLoadingSubmitBtn(true);
      if (formik.values.sportsCategories.length === 0) {
        setCategoryError(true);
        setIsLoadingSubmitBtn(false);
        return;
      } else {
        let config = {
          method: "patch",
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_BASE_URL}/api/coach/${id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          data: JSON.stringify(values),
        };

        axios
          .request(config)
          .then((response) => {

            setIsLoadingSubmitBtn(false);
            toast({
              title: "Coach professional Details updated",
              status: "success",
              duration: 4000,
              position: "top",
              isClosable: true,
            });
          })
          .catch((error) => {
            console.log(error);
            setIsLoadingSubmitBtn(false);
            if (error.response.status === 403) {
              toast({
                title: "You don't have an access to perform this action",
                status: "warning",
                duration: 4000,
                position: "top",
                isClosable: true,
              });
            } else {
              toast({
                title: "Something went wrong please try again later",
                status: "error",
                duration: 4000,
                position: "top",
                isClosable: true,
              });
            }
          });
      }
    },
  });

  useEffect(() => {
    setCoachingQualificationsImages(coachData?.coachingQualifications);
    setAwardImages(coachData?.award);
    setPlayingExperienceImages(coachData?.playerExperience);
    setCoachingExperienceImages(coachData?.coachingExperience);
  }, [id, coachData]);

  useEffect(() => {
    if (formik.values && !initialValuesRef.current) {
      initialValuesRef.current = JSON.parse(JSON.stringify(formik.values));
    }
  }, [formik.values]);


  return (
    <>
      <form>
        <Card
          pointerEvents={
            !userData?.accessScopes?.coach?.includes("write") ? "none" : "auto"
          }
        >
          <CardBody>
            <Heading as="h4" size="md" mb="25px" flexBasis={"30%"}>
              Professional Details
            </Heading>
            <Flex justifyContent={"space-between"} alignItems={"center"} my={4}>
              <FormControl
                flexBasis={"48%"}
                isInvalid={
                  formik.touched.experience && formik.errors.experience
                }
              >
                <FormLabel htmlFor="experience">
                  Experience <Text as="span" color="red.500">*</Text>
                </FormLabel>
                <Input
                  type="text"
                  name="experience"
                  id="experience"
                  autoComplete="none"
                  placeholder="Enter no. of experience"
                  value={formik.values.experience}
                  onChange={(e) => {
                    const raw = e.target.value || "";
                    const cleaned = raw.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, '$1').replace(/(\.[0-9]).*/g, '$1');
                    formik.setFieldValue("experience", cleaned);
                    formik.setFieldTouched("experience", true, false);
                    handleFormChange();
                  }}
                  onKeyDown={(e) => {
                    if (e.ctrlKey || e.metaKey) return;
                    if (e.key && e.key.length === 1 && !/^[0-9.]$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    const paste = e.clipboardData.getData("text") || "";
                    const cleaned = paste.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, '$1').replace(/(\.[0-9]).*/g, '$1');
                    if (cleaned !== "") {
                      const newVal = `${formik.values.experience || ""}${cleaned}`;
                      formik.setFieldValue("experience", newVal);
                      formik.setFieldTouched("experience", true, false);
                      handleFormChange();
                    }
                  }}
                />
                {formik.touched.experience && formik.errors.experience && (
                  <FormErrorMessage>
                    {formik.errors.experience}
                  </FormErrorMessage>
                )}
              </FormControl>
              <FormControl
                flexBasis={"48%"}
                isInvalid={formik.touched.language && formik.errors.language}
              >
                <FormLabel htmlFor="language">
                  Language <Text as="span" color="red.500">*</Text>
                </FormLabel>
                <Input
                  type="text"
                  name="language"
                  id="language"
                  autoComplete="none"
                  placeholder="Enter languages separated by commma( , )"
                  {...formik.getFieldProps("language")}
                  onChange={handleLanguageInput}
                  onKeyDown={(e) => {
                    if (e.ctrlKey || e.metaKey) return;
                    if (e.key && e.key.length === 1 && !/^[A-Za-z\s,\'-]$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    const paste = e.clipboardData.getData('text') || '';
                    const cleaned = paste.replace(/[^A-Za-z\s,\'-]/g, '');
                    const newVal = (formik.values.language || '') + cleaned;
                    formik.setFieldValue('language', newVal);
                    handleFormChange();
                  }}
                />
                {formik.touched.language && formik.errors.language && (
                  <FormErrorMessage>{formik.errors.language}</FormErrorMessage>
                )}
              </FormControl>
            </Flex>
            <FormControl isInvalid={formik.touched.sportsCategories && formik.errors.sportsCategories}>
              <FormLabel>
                Sports Category <Text as="span" color="red.500">*</Text>
              </FormLabel>
              <Menu>
                <MenuButton
                  as={Button}
                  w={"100%"}
                  rightIcon={<FaChevronDown />}
                >
                  Select Category
                </MenuButton>
                <MenuList minW={window.innerWidth - 600 + "px"}>
                  {categories.map((category, i) => (
                    <Box p={2} key={i}>
                      <Checkbox
                        size="md"
                        id={i}
                        colorScheme="green"
                        value={category} // Set the value to the category itself
                        isChecked={formik.values.sportsCategories.includes(
                          category.name
                        )}
                        onChange={(value) => {
                          if (value.target.checked) {
                            setCategoryError(false);
                            formik.setValues({
                              ...formik.values,
                              sportsCategories: [
                                ...formik.values.sportsCategories,
                                category.name,
                              ],
                            });
                          } else {
                            if (formik.values.sportsCategories.length > 0) {
                              setCategoryError(false);
                            } else {
                              setCategoryError(true);
                            }
                            formik.setValues({
                              ...formik.values,
                              sportsCategories:
                                formik.values.sportsCategories.filter(
                                  (x) => x !== category.name
                                ),
                            });
                          }
                          handleFormChange();
                        }}
                      >
                        {category.name}
                      </Checkbox>
                    </Box>
                  ))}
                </MenuList>
              </Menu>
              <Box mt={2}>
                <Flex wrap="wrap" gap={2}>
                  {formik?.values?.sportsCategories?.map((category, i) => (
                    <Tag
                      size={'md'}
                      key={i}
                      variant="solid"
                      colorScheme="teal"
                      whiteSpace="nowrap"
                      flex={{ base: "0 0 calc(33.33% - 8px)", md: "0 0 auto" }}
                    >
                      {category}
                    </Tag>
                  ))}
                </Flex>
              </Box>
              {(categoryError || (formik.touched.sportsCategories && formik.errors.sportsCategories)) && (
                <FormErrorMessage>
                  {formik.errors.sportsCategories || "Categories are required"}
                </FormErrorMessage>
              )}
            </FormControl>
            {/* Coaching Qualification */}
            <Box mt={6} mx={0}>
              <Flex
                justifyContent={"space-between"}
                alignItems={"center"}
                px={4}
                py={4}
              >
                <Heading as="h4" size={{ base: "sm", md: "md" }} whiteSpace="nowrap" mb={0} flexBasis={"30%"}>
                  Coaching Qualification
                </Heading>
                <Button
                  colorScheme="green"
                  size={"sm"}
                  px={4}
                  type="button"
                  onClick={addQualification}
                  isDisabled={formik.values.coachingQualifications.length >= 10}
                >
                  Add {formik.values.coachingQualifications.length >= 10 ? '(Max 10)' : ''}
                </Button>
              </Flex>
              {formik.values.coachingQualifications.map(
                (qualification, index) => {
                  return (
                    <Card m={4} mx={0} key={index}>
                      <CardBody>
                        <FormControl>
                          <Flex
                            justifyContent={"space-between"}
                            alignItems={"center"}
                            mb={4}
                          >
                            <Heading as="h4" size="md" mb={0}>
                              {"Coaching Qualification " + (index + 1)}
                            </Heading>
                            {index !== 0 &&
                              userData?.accessScopes?.coach?.includes(
                                "delete"
                              ) && (
                                <Button
                                  colorScheme="red"
                                  size={"sm"}
                                  px={4}
                                  onClick={() => {
                                    formik.setValues((prevState) => ({
                                      ...prevState,
                                      coachingQualifications:
                                        prevState.coachingQualifications.filter(
                                          (_, i) => i !== index
                                        ),
                                    }));
                                    handleFormChange();
                                  }}
                                >
                                  Remove
                                </Button>
                              )}
                          </Flex>
                          <Divider />
                          <Flex
                            justifyContent={"space-between"}
                            alignItems={"center"}
                            direction={{ base: "column", md: "row" }}
                          >
                            <Textarea
                              name={`coachingQualifications.${index}.description`}
                              id={`coachingQualifications.${index}.description`}
                              placeholder={"Enter coaching qualification"}
                              {...formik.getFieldProps(
                                `coachingQualifications.${index}.description`
                              )}
                              onChange={(e) => {
                                formik.handleChange(e);
                                handleFormChange();
                              }}
                              flexBasis={"60%"}
                              mb={{ base: 4, md: 0 }}
                            />
                            <Flex
                              flexDirection="column"
                              alignItems="flex-start"
                              flexBasis={"33%"}
                            >
                              {formik?.values?.coachingQualifications[index]
                                ?.image && (
                                  <>
                                    <a
                                      href={`${formik?.values?.coachingQualifications[index]?.image}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <Image
                                        src={
                                          formik?.values?.coachingQualifications[
                                            index
                                          ]?.image
                                        }
                                        id={`coachingQualifications.${index}.image`}
                                        alt="Selected Image"
                                        maxW="165px"
                                        maxH="165px"
                                      />
                                    </a>
                                    {userData?.accessScopes?.coach?.includes(
                                      "delete"
                                    ) && (
                                        <Button
                                          mt={2}
                                          colorScheme="red"
                                          size={"sm"}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            formik.setFieldValue(
                                              `coachingQualifications.${index}.image`,
                                              ""
                                            );
                                            setCoachingQualificationsImages(
                                              coachingQualificationsImages.filter(
                                                (x, idx) => idx !== index
                                              )
                                            );
                                            deleteImageFiles(
                                              qualification.image,
                                              "coachingQualifications",
                                              index
                                            );
                                          }}
                                        >
                                          Remove Image
                                        </Button>
                                      )}
                                  </>
                                )}
                              {formik.values.coachingQualifications[index]
                                ?.image === "" && (
                                  <Box>
                                    <Text as={"span"} fontWeight={"semibold"}>
                                      Add Image
                                    </Text>
                                    <Input
                                      type="file"
                                      id={`coachingQualifications.${index}.image`}
                                      name={`coachingQualifications.${index}.image`}
                                      accept="image/*"
                                      onChange={(e) =>
                                        handleFileChange(
                                          e,
                                          "coachingQualifications",
                                          index
                                        )
                                      }
                                      mt={1}
                                      cursor={"pointer"}
                                    />
                                  </Box>
                                )}
                            </Flex>
                          </Flex>
                        </FormControl>
                      </CardBody>
                    </Card>
                  );
                }
              )}
            </Box>

            {/* Coacing Experience */}
            <Box mt={6} mx={0}>
              <Flex
                justifyContent={"space-between"}
                alignItems={"center"}
                px={4}
                py={4}
              >
                <Heading as="h4" size={{ base: "sm", md: "md" }} whiteSpace="nowrap" mb={0} flexBasis={"30%"}>
                  Coaching Experience
                </Heading>
                <Button
                  colorScheme="green"
                  size={"sm"}
                  px={4}
                  type="button"
                  onClick={addCoachingExperience}
                  isDisabled={formik.values.coachingExperience.length >= 10}
                >
                  Add {formik.values.coachingExperience.length >= 10 ? '(Max 10)' : ''}
                </Button>
              </Flex>
              {formik.values.coachingExperience.map((experience, index) => {
                return (
                  <Card m={4} mx={0} key={index}>
                    <CardBody>
                      <FormControl>
                        <Flex
                          justifyContent={"space-between"}
                          alignItems={"center"}
                          mb={4}
                        >
                          <Heading as="h4" size="md" mb={0}>
                            {"Coaching Experience " + (index + 1)}
                          </Heading>
                          {index !== 0 &&
                            userData?.accessScopes?.coach?.includes(
                              "delete"
                            ) && (
                              <Button
                                colorScheme="red"
                                size={"sm"}
                                px={4}
                                onClick={() =>
                                  formik.setValues((prevState) => ({
                                    ...prevState,
                                    coachingExperience:
                                      prevState.coachingExperience.filter(
                                        (_, i) => i !== index
                                      ),
                                  }))
                                }
                              >
                                Remove
                              </Button>
                            )}
                        </Flex>
                        <Divider />
                        <Flex
                          justifyContent={"space-between"}
                          alignItems={"center"}
                          direction={{ base: "column", md: "row" }}
                        >
                          <Textarea
                            name={`coachingExperience.${index}.description`}
                            id={`coachingExperience.${index}.description`}
                            placeholder={"Enter coaching experience"}
                            {...formik.getFieldProps(
                              `coachingExperience.${index}.description`
                            )}
                            onChange={(e) => {
                              formik.handleChange(e);
                              handleFormChange();
                            }}
                            flexBasis={"60%"}
                            mb={{ base: 4, md: 0 }}
                          />
                          <Flex
                            flexDirection="column"
                            alignItems="flex-start"
                            flexBasis={"33%"}
                          >
                            {formik?.values?.coachingExperience[index]
                              ?.image && (
                                <>
                                  <a
                                    href={`${formik?.values?.coachingExperience[index]?.image}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <Image
                                      src={
                                        formik?.values?.coachingExperience[index]
                                          ?.image
                                      }
                                      id={`coachingExperience.${index}.image`}
                                      alt="Selected Image"
                                      maxW="165px"
                                      maxH="165px"
                                    />
                                  </a>
                                  {userData?.accessScopes?.coach?.includes(
                                    "delete"
                                  ) && (
                                      <Button
                                        mt={2}
                                        colorScheme="red"
                                        size={"sm"}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          formik.setFieldValue(
                                            `coachingExperience.${index}.image`,
                                            ""
                                          );
                                          setCoachingExperienceImages(
                                            coachingExperienceImages.filter(
                                              (x, idx) => idx !== index + 1
                                            )
                                          );
                                          deleteImageFiles(
                                            experience.image,
                                            "coachingExperience",
                                            index
                                          );
                                        }}
                                      >
                                        Remove Image
                                      </Button>
                                    )}
                                </>
                              )}
                            {formik.values.coachingExperience[index]?.image ===
                              "" && (
                                <>
                                  <Text as={"span"} fontWeight={"semibold"}>
                                    Add Image
                                  </Text>
                                  <Input
                                    type="file"
                                    id={`coachingExperience.${index}.image`}
                                    name={`coachingExperience.${index}.image`}
                                    accept="image/*"
                                    onChange={(e) =>
                                      handleFileChange(
                                        e,
                                        "coachingExperience",
                                        index
                                      )
                                    }
                                    mt={1}
                                    cursor={"pointer"}
                                  />
                                </>
                              )}
                          </Flex>
                        </Flex>
                      </FormControl>
                    </CardBody>
                  </Card>
                );
              })}
            </Box>

            {/* Playing Experience */}
            <Box mt={6} mx={0}>
              <Flex
                justifyContent={"space-between"}
                alignItems={"center"}
                px={4}
                py={4}
              >
                <Heading as="h4" size={{ base: "sm", md: "md" }} whiteSpace="nowrap" mb={0} flexBasis={"30%"}>
                  Playing Experience
                </Heading>
                <Button
                  colorScheme="green"
                  size={"sm"}
                  px={4}
                  type="button"
                  onClick={addPlayingExperience}
                  isDisabled={formik.values.playerExperience.length >= 10}
                >
                  Add {formik.values.playerExperience.length >= 10 ? '(Max 10)' : ''}
                </Button>
              </Flex>
              {formik.values.playerExperience.map((experience, index) => {
                return (
                  <Card m={4} mx={0} key={index}>
                    <CardBody>
                      <FormControl>
                        <Flex
                          justifyContent={"space-between"}
                          alignItems={"center"}
                          mb={4}
                        >
                          <Heading as="h4" size="md" mb={0}>
                            {"Playing Experience " + (index + 1)}
                          </Heading>
                          {index !== 0 &&
                            userData?.accessScopes?.coach?.includes(
                              "delete"
                            ) && (
                              <Button
                                colorScheme="red"
                                size={"sm"}
                                px={4}
                                onClick={() =>
                                  formik.setValues((prevState) => ({
                                    ...prevState,
                                    playerExperience:
                                      prevState.playerExperience.filter(
                                        (_, i) => i !== index
                                      ),
                                  }))
                                }
                              >
                                Remove
                              </Button>
                            )}
                        </Flex>
                        <Divider />
                        <Flex
                          justifyContent={"space-between"}
                          alignItems={"center"}
                          direction={{ base: "column", md: "row" }}
                        >
                          <Textarea
                            name={`playerExperience.${index}.description`}
                            id={`playerExperience.${index}.description`}
                            placeholder={"Enter playing experience"}
                            {...formik.getFieldProps(
                              `playerExperience.${index}.description`
                            )}
                            onChange={(e) => {
                              formik.handleChange(e);
                              handleFormChange();
                            }}
                            flexBasis={"60%"}
                            mb={{ base: 4, md: 0 }}
                          />
                          <Flex
                            flexDirection="column"
                            alignItems="flex-start"
                            flexBasis={"33%"}
                          >
                            {formik?.values?.playerExperience[index]?.image && (
                              <>
                                <a
                                  href={`${formik?.values?.playerExperience[index]?.image}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <Image
                                    src={
                                      formik?.values?.playerExperience[index]
                                        ?.image
                                    }
                                    id={`playerExperience.${index}.image`}
                                    alt="Selected Image"
                                    maxW="165px"
                                    maxH="165px"
                                  />
                                </a>
                                {userData?.accessScopes?.coach?.includes(
                                  "delete"
                                ) && (
                                    <Button
                                      mt={2}
                                      colorScheme="red"
                                      size={"sm"}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        formik.setFieldValue(
                                          `playerExperience.${index}.image`,
                                          ""
                                        );
                                        setPlayingExperienceImages(
                                          playingExperienceImages.filter(
                                            (_, idx) => idx !== index + 1
                                          )
                                        );
                                        deleteImageFiles(
                                          experience.image,
                                          "playerExperience",
                                          index
                                        );
                                      }}
                                    >
                                      Remove Image
                                    </Button>
                                  )}
                              </>
                            )}
                            {formik.values.playerExperience[index]?.image ===
                              "" && (
                                <>
                                  <Text as={"span"} fontWeight={"semibold"}>
                                    Add Image
                                  </Text>
                                  <Input
                                    type="file"
                                    id={`playerExperience.${index}.image`}
                                    name={`playerExperience.${index}.image`}
                                    accept="image/*"
                                    onChange={(e) =>
                                      handleFileChange(
                                        e,
                                        "playerExperience",
                                        index
                                      )
                                    }
                                    mt={1}
                                    cursor={"pointer"}
                                  />
                                </>
                              )}
                          </Flex>
                        </Flex>
                      </FormControl>
                    </CardBody>
                  </Card>
                );
              })}
            </Box>

            {/* Award */}
            <Box mt={6} mx={0}>
              <Flex
                justifyContent={"space-between"}
                alignItems={"center"}
                px={4}
                py={4}
              >
                <Heading as="h4" size={{ base: "sm", md: "md" }} whiteSpace="nowrap" mb={0} flexBasis={"30%"}>
                  Award
                </Heading>
                <Button
                  colorScheme="green"
                  size={"sm"}
                  px={4}
                  type="button"
                  onClick={addAwardExperience}
                  isDisabled={formik.values.award.length >= 10}
                >
                  Add {formik.values.award.length >= 10 ? '(Max 10)' : ''}
                </Button>
              </Flex>
              {formik.values.award.map((award, index) => {
                return (
                  <Card m={4} mx={0} key={index}>
                    <CardBody>
                      <FormControl>
                        <Flex
                          justifyContent={"space-between"}
                          alignItems={"center"}
                          mb={4}
                        >
                          <Heading as="h4" size="md" mb={0}>
                            {"Award " + (index + 1)}
                          </Heading>
                          {index !== 0 &&
                            userData?.accessScopes?.coach?.includes(
                              "delete"
                            ) && (
                              <Button
                                colorScheme="red"
                                size={"sm"}
                                px={4}
                                onClick={() =>
                                  formik.setValues((prevState) => ({
                                    ...prevState,
                                    award: prevState.award.filter(
                                      (_, i) => i !== index
                                    ),
                                  }))
                                }
                              >
                                Remove
                              </Button>
                            )}
                        </Flex>
                        <Divider />
                        <Flex
                          justifyContent={"space-between"}
                          alignItems={"center"}
                          direction={{ base: "column", md: "row" }}
                        >
                          <Textarea
                            name={`award.${index}.description`}
                            id={`award.${index}.description`}
                            placeholder={"Enter award details"}
                            {...formik.getFieldProps(
                              `award.${index}.description`
                            )}
                            onChange={(e) => {
                              formik.handleChange(e);
                              handleFormChange();
                            }}
                            flexBasis={"60%"}
                            mb={{ base: 4, md: 0 }}
                          />
                          <Flex
                            flexDirection="column"
                            alignItems="flex-start"
                            flexBasis={"33%"}
                          >
                            {award?.image && (
                              <>
                                <a
                                  href={`${award?.image}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <Image
                                    src={award?.image}
                                    id={`award.${index}.image`}
                                    alt="Selected Image"
                                    maxW="165px"
                                    maxH="165px"
                                  />
                                </a>
                                {userData?.accessScopes?.coach?.includes(
                                  "delete"
                                ) && (
                                    <Button
                                      mt={2}
                                      colorScheme="red"
                                      size={"sm"}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        formik.setFieldValue(
                                          `award.${index}.image`,
                                          ""
                                        );
                                        setAwardImages(
                                          awardImages.filter(
                                            (_, idx) => idx !== index
                                          )
                                        );
                                        deleteImageFiles(
                                          awardImages[index]?.image,
                                          "award",
                                          index
                                        );
                                      }}
                                    >
                                      Remove Image
                                    </Button>
                                  )}
                              </>
                            )}
                            {formik.values.award[index]?.image === "" && (
                              <>
                                <Text as={"span"} fontWeight={"semibold"}>
                                  Add Image
                                </Text>
                                <Input
                                  type="file"
                                  id={`award.${index}.image`}
                                  name={`award.${index}.image`}
                                  accept="image/*"
                                  onChange={(e) =>
                                    handleFileChange(e, "award", index)
                                  }
                                  mt={1}
                                  cursor={"pointer"}
                                />
                              </>
                            )}
                          </Flex>
                        </Flex>
                      </FormControl>
                    </CardBody>
                  </Card>
                );
              })}
            </Box>
          </CardBody>
        </Card>
        {userData?.accessScopes?.coach?.includes("write") && (
          <Flex justifyContent={"space-between"} alignItems={"center"} mt={4}>
            <Button
              colorScheme="red"
              flexBasis={"49%"}
              isDisabled={isDiscardDisabled || !formChanged}
              onClick={() => {
                formik.resetForm();
                setIsDiscardDisabled(true);
                setFormChanged(false);
                toast({
                  title: "All Changes has been discarded",
                  status: "success",
                  duration: 4000,
                  position: "top",
                  isClosable: true,
                });
              }}
            >
              Discard
            </Button>
            <Button
              colorScheme="green"
              flexBasis={"49%"}
              type="submit"
              onClick={formik.handleSubmit}
              isLoading={isLoadingSubmitBtn}
            >
              Update
            </Button>
          </Flex>
        )}
      </form>
    </>
  );
};

export default ProfessionalDetails;
